import React from "react";
import { Layout, Card } from 'antd';
import WebsiteIndexEntryTabs from '../../deepAnalysis/websiteIndexEntry/WebsiteIndexEntryTabs';
import useGetCurrentWebsite from "../../deepAnalysis/websiteIndexEntry/hooks/useGetCurrentWebsite";
import VisibilityAnalysis from "../visibilityAnalysis/VisibilityAnalysis";
import useGetPlanSettings from "../../sales/hooks/useGetPlanSettings";
import DisabledFeature from "../../shared/DisabledFeature";
import LoadingIndicator from "../../components/shared/LoadingIndicator/LoadingIndicator";

const { Content } = Layout;


export default function LLMVisibilityAnalysisPage() {
    const { website: selectedWebsite } = useGetCurrentWebsite();
    const domain = selectedWebsite?.domain || "";
    const { allowLLMVisibility, isLoading: isLoadingPlanSettings } = useGetPlanSettings();

    return (
        <Content className="general-layout-content">
            {isLoadingPlanSettings && <LoadingIndicator />}
            {!isLoadingPlanSettings && allowLLMVisibility === false && (
                <Card className="ai-content-analysis-no-access-card">
                    <DisabledFeature />
                </Card>
            )}
            {(!isLoadingPlanSettings && allowLLMVisibility === true) && (
                <WebsiteIndexEntryTabs>
                    {domain ? <VisibilityAnalysis domain={domain} /> : null}
                </WebsiteIndexEntryTabs>
            )}
        </Content>
    );
}